// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playlistPopoverContent_root__FvUjh {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline; }\n  .playlistPopoverContent_root__FvUjh .playlistPopoverContent_title__3wPFK {\n    margin-bottom: 20px;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 22px;\n    color: #333333;\n    margin-top: 10px;\n    text-align: center;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .playlistPopoverContent_root__FvUjh .playlistPopoverContent_content__ktU0b {\n    display: flex; }\n    .playlistPopoverContent_root__FvUjh .playlistPopoverContent_content__ktU0b .playlistPopoverContent_input__2NnP1 {\n      width: 300px !important; }\n", ""]);
// Exports
exports.locals = {
	"root": "playlistPopoverContent_root__FvUjh",
	"title": "playlistPopoverContent_title__3wPFK",
	"content": "playlistPopoverContent_content__ktU0b",
	"input": "playlistPopoverContent_input__2NnP1"
};
module.exports = exports;
